import HttpClient from "../../js/repository/HttpClient.js";
import UserHeaderCmp from "../../components/page-header/UserHeaderCmp.js";
import OrgRepository from "../../js/repository/OrgRepository.js";
import PostPageCmp from "./PostPageCmp.js";
import PostPageHeaderCmp from "./PostPageHeader/PostPageHeaderCmp.js";
import PostRepository from "../../js/repository/PostRepository.js";
import TeamRepository from "../../js/repository/TeamRepository.js";
import UserRepository from "../../js/repository/UserRepository.js";
import PermissionRepository from "../../js/repository/PermissionRepository.js";

export default class PostPageIoC {
	/** @type {Map<string, any>} */
	#cached = new Map();
	/** @type {SecurityContext} */
	#securityContext;

	/**
	 * @param {SecurityContext} securityContext
	 * @see {HttpClient#createSecurityContext}
	 */
	constructor(securityContext) {
		if (!securityContext)
			throw new Error('Security context is required');
		this.#securityContext = securityContext;
		/** @type {Map<string, any>} */
		this.#cached = new Map();
	}

	/** @return {PostPageCmp} */
	getPostPageCmp() {
		return this.#cache('postPageCmp', () => new PostPageCmp(this.#securityContext, this));
	}

	/** @returns {PostPageHeaderCmp} */
	getPageHeaderCmp() {
		return this.#cache('postPageHeaderCmp', () => new PostPageHeaderCmp(this.getUserHeaderCmp()));
	}

	/** @returns {UserHeaderCmp} */
	getUserHeaderCmp(){
		return this.#cache("userHeaderCmp", ()=> new UserHeaderCmp(this.getOrganizationRepository()))
	}

	/** @returns {OrgRepository} */
	getOrganizationRepository() {
		return this.#cache('organizationRepo', () => new OrgRepository(this.getHttpClient()));
	}

	/** @returns {PostRepository} */
	getPostRepository() {
		return this.#cache('postRepo', () => new PostRepository(this.getHttpClient()));
	}

	/** @returns {TeamRepository} */
	getTeamRepository() {
		return this.#cache('teamRepo', () => new TeamRepository(this.getHttpClient()));
	}

	/** @returns {UserRepository} */
	getUserRepository() {
		return this.#cache('userRepo', () => new UserRepository(this.getHttpClient()));
	}

	/** @returns {PermissionRepository} */
	getPermissionRepository() {
		return this.#cache('permissionRepo', () => new PermissionRepository(this.getHttpClient()));
	}

	/** @returns {HttpClient} */
	getHttpClient() {
		return this.#cache('httpClient', () => new HttpClient('', this.#securityContext));
	}

	/**
	 * @returns {any}
	 * @private
	 */
	#cache(cmpName, createCmpFn) {
		let cmp = this.#cached.get(cmpName);
		if (!cmp) {
			cmp = createCmpFn();
			this.#cached.set(cmpName, cmp);
		}
		return cmp;
	}
}